export class PaginationComponent {
  element = null;
  appendSelector = null;

  constructor(currentPage = 1, totalPages = 1, appendSelector) {
    this.appendSelector = appendSelector;
    this.createPaginationElement(parseInt(currentPage), parseInt(totalPages));
  }

  getPaginationElement() {
    return this.element;
  }

  appendPaginationElement() {
    if (!this.appendSelector) {
      return;
    }

    const paginationElement = this.appendSelector.querySelector('.c-pagination');
    if (paginationElement) {
      paginationElement.remove();
    }

    if (!this.element) {
      return;
    }

    this.appendSelector.appendChild(this.element);
  }

  createPaginationElement(currentPage, totalPages, withPrevNext = false) {
    if (totalPages < 2) {
      this.element = null;
      return;
    }

    const paginationElement = document.createElement('div');
    paginationElement.className = 'c-pagination';

    if (withPrevNext) {
      const prevPageElement = this.createPrevPageElement(currentPage);
      if (!prevPageElement) {
        this.element = null;
        return;
      }

      paginationElement.appendChild(prevPageElement);
    }

    const pageList = this.getPageList(currentPage, totalPages);
    if (!pageList) {
      this.element = null;
      return;
    }

    pageList.forEach((page) => {
      paginationElement.appendChild(page);
    });

    if (withPrevNext) {
      const nextPageElement = this.createNextPageElement(totalPages);
      if (!nextPageElement) {
        this.element = null;
        return;
      }

      paginationElement.appendChild(nextPageElement);
    }

    this.element = paginationElement;
  }

  createPrevPageElement(currentPage) {
    const prevPageElement = currentPage === 1
      ? document.createElement('span')
      : document.createElement('a');

    prevPageElement.className = 'prev';

    const iconElement = document.createElement('i');
    iconElement.className = 'fas fa-angle-left';

    prevPageElement.appendChild(iconElement);

    return prevPageElement;
  }

  createDotsElement() {
    const dotsElement = document.createElement('span');
    dotsElement.innerHTML = '...';

    return dotsElement;
  }

  createPageElement(currentPage, index) {
    const pageElement = currentPage === index
      ? document.createElement('span')
      : document.createElement('a');

    pageElement.className = 'page';
    pageElement.innerHTML = index;

    return pageElement;
  }

  getPageList(currentPage, totalPages) {
    let isDotsAfter = false;
    let isDotsBefore = false;

    const pageList = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === currentPage || i === totalPages) {
        pageList.push(this.createPageElement(currentPage, i));

        continue;
      }

      if (totalPages > 6 && (i < currentPage - 2 || i > currentPage + 2)) {
        if (currentPage >= i + 3 && !isDotsBefore) {
          isDotsBefore = true;
          pageList.push(this.createDotsElement());
        }

        if (currentPage <= i - 3 && !isDotsAfter) {
          isDotsAfter = true;
          pageList.push(this.createDotsElement());
        }

        continue;
      }

      pageList.push(this.createPageElement(currentPage, i));
    }

    return pageList;
  }

  createNextPageElement(currentPage, totalPages) {
    const nextPageElement = currentPage === totalPages
      ? document.createElement('span')
      : document.createElement('a');

    nextPageElement.className = 'next';

    const iconElement = document.createElement('i');
    iconElement.className = 'fas fa-angle-right';

    nextPageElement.appendChild(iconElement);

    return nextPageElement;
  }
}